import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { useTranslation } from 'react-i18next';
import useIsMobile from '../../../hooks/global/UseIsMobile';

interface MobileHeaderSearchProps {
  value: string;
  onChange: (value: string) => void;
}

/**
 * Wyszukiwarka do akcji strony w górnym pasku telefonu (`MobilePageHeader`): lupa, która rozwija się
 * w pole w miejscu logo i pozostałych akcji strony (chowa je `MobileMenu.scss`). Zamknięcie czyści
 * frazę — inaczej filtrowałaby listę bez widocznego pola. Tak samo po przejściu na szerszy ekran.
 */
const MobileHeaderSearch: React.FC<MobileHeaderSearchProps> = ({ value, onChange }) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(false);

  const close = () => {
    setOpen(false);
    onChange('');
  };

  useEffect(() => {
    if (!isMobile && open) {
      close();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);

  if (!open) {
    return (
      <button
        type="button"
        className="mobile-header__icon-btn"
        onClick={() => setOpen(true)}
        aria-label={t('mobileSearch')}
      >
        <span className="ico--search ico--sm" />
      </button>
    );
  }

  return (
    <div className="mobile-header__search">
      <div className="input-search-box">
        <InputText
          autoFocus
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={t('searchPlaceholder')}
          className="input-search"
        />
      </div>
      <button type="button" className="mobile-header__icon-btn" onClick={close} aria-label={t('close')}>
        <span className="ico--plus ico--sm mobile-header__search-close" />
      </button>
    </div>
  );
};

export default MobileHeaderSearch;
